import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { Saloonhome } from "./pages/Saloonhome";
import { useEffect } from "react";
import { SalonAthome } from "./pages/salonAthome";
import CheckoutPage from "./pages/checkout";
import Profile from "./pages/profile";
import Waxing from "./pages/waxing";
import Facial from "./pages/facial";
import Notfound from "./pages/notfound";
import { Toaster } from "react-hot-toast";
import Medianav from "./pages/medianav";
import MainLayout from "./components/MainLayout";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getCategory } from "./redux/category/categorySlice";
import { getSuperCategory } from "./redux/superCategory/superCategorySlice";
import { getSubCategory } from "./redux/subCategory/subCategorySlice";
import CartPage from "./pages/CartPage";
import Payments from "./pages/Payments";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import FailurePayment from "./pages/FailurePayment";
import Privacy from "./pages/Privacy";
import TermsNdConditions from "./pages/TermsNdConditions";
import Faqs from "./pages/Faqs";
import { getTag } from "./redux/tags/TagSlice";
import CancellationPage from "./pages/CancellationPage";
import RefundPage from "./pages/RefundPage";
import ShippingPolicy from "./pages/ShippingPolicy";
import SubcategoryPage from "./pages/SubcategoryPage";
import SalonPage from "./pages/Saloon/SaloonPage";
import {
  getAllCategoriesBySaloon,
  getSaloonList,
} from "./redux/saloon/SaloonSlice";
import SalonList from "./pages/SalonList";
import SaloonSearchPage from "./pages/Saloon/SaloonSearchPage";
import EditAddressModel from "./pages/EditAddressModel";
import ProductCheckout from "./pages/ProductCheckout";
import AddSaloon from "./pages/AddSaloon";
import Privacy1 from "./pages/farmareck/Privacy";
import ScheduleSlot from "./pages/ScheduleSlot";
import SuccessfulPayment from "./pages/SuccessfulPayment";
import SucessfulPaymentSalon from "./pages/SucessfulPaymentSalon";

// Import cart and order actions
import { fetchCartFromBackend, initializeCartFromLocalStorage } from "./redux/cart/CartSlice";
import { fetchSalonHomeCartFromBackend, initializeSalonHomeCartFromLocalStorage } from "./redux/cart/HomeSalon";
import { getOrdersByClientId } from "./redux/order/OrderSlice";
import { getHomeSalonOrdersByClientId } from "./redux/order/OrderSalonHomeSlice";
import Editprofile from "./pages/account/Editprofile";
import ShopOrder from "./pages/account/ShopOrder";
import SalonOrders from "./pages/account/SalonOrders";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Auth validation and data fetching hook
const useAuthValidationAndDataFetch = () => {
  const dispatch = useDispatch();
  const { isAuth, loginData, clientid } = useSelector((store) => store.Authentication);

  useEffect(() => {
    // Check if we have auth data in localStorage but Redux state is not synced
    const savedAuthData = localStorage.getItem('authState');
    if (savedAuthData && !isAuth) {
      try {
        const authData = JSON.parse(savedAuthData);
        if (authData.isAuth && authData.loginData) {
          console.log('Auth state restored from localStorage on App mount');
        }
      } catch (error) {
        console.error('Error validating auth state:', error);
        localStorage.removeItem('authState');
      }
    }

    // Initialize cart from localStorage for guest users
    if (!isAuth) {
      dispatch(initializeCartFromLocalStorage());
      dispatch(initializeSalonHomeCartFromLocalStorage());
    }
  }, [dispatch, isAuth]);

  // Fetch cart and order data when authenticated or on refresh
  useEffect(() => {
    const fetchUserData = async () => {
      if (isAuth && clientid) {
        console.log('Fetching user data for client:', clientid);
        
        try {
          // Fetch regular cart data
          await dispatch(fetchCartFromBackend()).unwrap();
          
          // Fetch home salon cart data
          await dispatch(fetchSalonHomeCartFromBackend()).unwrap();
          
          // Fetch regular orders
          await dispatch(getOrdersByClientId(clientid)).unwrap();
          
          // Fetch home salon orders
          await dispatch(getHomeSalonOrdersByClientId(clientid)).unwrap();
          
          console.log('User data fetched successfully');
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      } else {
        console.log('User not authenticated, loading guest cart from localStorage');
        
        // Load guest cart from localStorage
        const guestCart = localStorage.getItem('CartItems');
        const guestSalonHomeCart = localStorage.getItem('salonHomeCartItems');
        
        if (guestCart) {
          try {
            const cartItems = JSON.parse(guestCart);
            dispatch(initializeCartFromLocalStorage());
          } catch (error) {
            console.error('Error parsing guest cart:', error);
          }
        }
        
        if (guestSalonHomeCart) {
          try {
            dispatch(initializeSalonHomeCartFromLocalStorage());
          } catch (error) {
            console.error('Error parsing guest salon home cart:', error);
          }
        }
      }
    };

    fetchUserData();
  }, [dispatch, isAuth, clientid]);

  // Clear data when user logs out
  useEffect(() => {
    if (!isAuth) {
      // Note: You might want to add actions to clear data when user logs out
      // dispatch(clearCart());
      // dispatch(clearSalonHomeCart());
      // dispatch(clearOrder());
      // dispatch(clearHomeSalonOrders());
    }
  }, [dispatch, isAuth]);
};

function App() {
  const { isAuth } = useSelector((store) => store.Authentication);
  const { superCategorytotal, isSuperCategoryAvailable, superCategoryLoading } =
    useSelector((store) => store.superCategory);

  const { categorytotal, categoryLoading, isCategoryAvailable } = useSelector(
    (store) => store.category
  );

  const { subCategorytotal, isSubCategoryAvailable, subCategoryLoading } =
    useSelector((store) => store.subCategory);

  const { tagtotal, isTagAvailable, tagLoading } = useSelector(
    (store) => store.Tag
  );
  const { saloonCategoryLoading, allCategoriesFromSaloon } = useSelector(
    (store) => store.saloon
  );

  const dispatch = useDispatch();

  // Initialize auth validation and data fetching
  useAuthValidationAndDataFetch();

  useEffect(() => {
    if (!isSuperCategoryAvailable || superCategorytotal.length === 0) {
      dispatch(getSuperCategory());
    }
    if (!isCategoryAvailable || categorytotal.length === 0) {
      dispatch(getCategory());
    }
    if (!isSubCategoryAvailable || subCategorytotal.length === 0) {
      dispatch(getSubCategory());
    }

    if (!isTagAvailable || tagtotal.length === 0) {
      dispatch(getTag());
    }
    if (!saloonCategoryLoading || allCategoriesFromSaloon.length === 0) {
      dispatch(getAllCategoriesBySaloon());
    }
    dispatch(getSaloonList());
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (superCategoryLoading) {
        dispatch(getSuperCategory());
      }
      if (categoryLoading) {
        dispatch(getCategory());
      }
      if (subCategoryLoading) {
        dispatch(getSubCategory());
      }
      if (tagLoading) {
        dispatch(getTag());
      }
    }, 15000);
    
    return () => clearTimeout(timeout);
  }, [superCategoryLoading, categoryLoading, subCategoryLoading, tagLoading, dispatch]);

  // Session expiration check
  useEffect(() => {
    const checkAuthExpiry = () => {
      const savedAuthData = localStorage.getItem('authState');
      if (savedAuthData) {
        try {
          const authData = JSON.parse(savedAuthData);
          // Optional: Check if auth data is older than 30 days
          const thirtyDays = 30 * 24 * 60 * 60 * 1000;
          const authTimestamp = authData.loginData?.createdAt || authData.timestamp;
          if (authTimestamp && (Date.now() - new Date(authTimestamp).getTime()) > thirtyDays) {
            localStorage.removeItem('authState');
            console.log('Auth data expired (30 days)');
            
            // Clear user data when auth expires
            // dispatch(clearCart());
            // dispatch(clearSalonHomeCart());
            // dispatch(clearOrder());
            // dispatch(clearHomeSalonOrders());
          }
        } catch (error) {
          localStorage.removeItem('authState');
        }
      }
    };

    checkAuthExpiry();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            theme: {
              primary: '#4CAF50',
              secondary: 'black',
            },
          },
          error: {
            duration: 5000,
          },
        }}
      />
      <div className="nav-sticky container-fluid">
        {/* <Header /> */}
      </div>
      <Routes>
        <Route path="/" exact element={<MainLayout />}>
          <Route path="/" index element={<Saloonhome />} />
          <Route path="/saloonhome/:slugurl" element={<SalonAthome />} />
          <Route path="/:caturl/:subcaturl" element={<SubcategoryPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/registersaloon" element={<AddSaloon />} />
          <Route path="/checkout" element={<CheckoutPage />} />  
          <Route path="/slot-booking" element={<ScheduleSlot />} />  
          <Route path="/product-checkout" element={<ProductCheckout />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/ShopOrderaccount" element={<ShopOrder />} />
          <Route path="/salonOrderaccount" element={<SalonOrders />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/success" element={<SuccessfulPayment />} />
          <Route path="/successsalon" element={<SucessfulPaymentSalon />} />
          <Route path="/failure" element={<FailurePayment />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/facial" element={<Facial />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/privacy" element={<Privacy1 />} />
          <Route path="/faq" element={<Faqs />} />
          <Route path="/terms-conditions" element={<TermsNdConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPage />} />
          <Route path="/refundPage" element={<RefundPage />} />
          <Route path="/ShippingPolicy" element={<ShippingPolicy />} />
          <Route path="/saloonNearMe" element={<SalonPage />} />
          <Route path="/search" element={<SaloonSearchPage />} />
          <Route path="/salonlist" element={<SalonList />} />
          <Route path="/editAddress/:id" element={<EditAddressModel />} />
          <Route path="/Editprofile" element={<Editprofile />} />
          <Route path="*" element={<Notfound />} />
        </Route>
      </Routes>
      {/* <Footer /> */}
      <div className="container-fluid-lg d-block">
        <Medianav />
      </div>
    </BrowserRouter>
  );
}

export default App;